export default __webpack_public_path__ + "static/media/stitch.faa65e07.png";